import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Terminal = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Terminal' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M2,5 L8,11 L2,17 M9,17 L23,17' />
  </StyledIcon>
);
